<template>
  <!-- <div @click="initSearchInputFlag"> -->
  <div>
    <!-- header开始 -->
    <div class="header">
      <div class="inner">
        <div class="fl logo">
          <a target="_blank" href="http://www.tianmen.gov.cn/">
            <img src="../assets/image/logo.png" />
          </a>
        </div>
        <div class="fr header_fr_box">
          <!-- 头部搜索框 -->
          <div class="search">
            <div class="search_box">
              <input
                id="searchInput"
                type="text"
                placeholder="请输入搜索关键词"
                @keyup.enter="searchFn"
                @input="showSuggestWords"
                @click.stop="showSuggestWords"
                v-click-outside="handleClickOutside"
                v-model="keywords"
              />
              <div
                id="searchInputClearBtn"
                v-show="searchInputClearBtnFlag"
                @click="clearSearchInputFn"
              >
                x
              </div>
              <button id="searchBtn" @click.stop="searchFn">
                <img src="../assets/image/icon_search.png" alt="" /> 搜 索
              </button>
              <!-- 搜索框搜索联想 -->
              <ul id="recommendWords" v-show="suggestWordsFlag">
                <li v-for="item in suggestWordsArr">
                  <a href="javascript:;" @click="addKeywords" v-html="item"></a>
                </li>
              </ul>
            </div>
          </div>
          <!-- 搜索框热门搜索 -->
          <div id="hotWords">
            <span>热门搜索：</span>
            <a
              href="javascript:;"
              @click="addKeywords"
              v-for="item in hotWordsArr"
              >{{ item }}</a
            >
          </div>
        </div>
      </div>
      <!-- 导航栏 -->
      <div class="nav">
        <ul class="inner">
          <el-tabs v-model="navActiveName" @tab-click="navHandleClick">
            <el-tab-pane
              :label="item.title"
              :name="item.title"
              v-for="item in navObjListArr"
            ></el-tab-pane>
          </el-tabs>
        </ul>
      </div>
    </div>
    <!-- header结束 -->

    <!-- main开始 -->
    <main>
      <div class="content inner">
        <!-- 搜索选项 -->
        <div class="search_option_box clearfix" v-if="!serviceFlag">
          <div class="search_option">
            <span>排序：</span>
            <button
              :class="sortBtnFlag ? 'cur' : ''"
              id="sortByRelationBtn"
              @click="
                setSearchOrderBy('all'),
                  setSearchTimeOrder(''),
                  (sortBtnFlag = true)
              "
            >
              按相关度
            </button>
            <button
              :class="sortBtnFlag ? '' : 'cur'"
              id="sortByDateBtn"
              @click="
                setSearchOrderBy('time'),
                  setSearchTimeOrder('desc'),
                  (sortBtnFlag = false)
              "
            >
              按时间
            </button>
          </div>
          <div class="search_option">
            <span>搜索范围：</span>
            <button
              :class="positionBtnFlag ? '' : 'cur'"
              id="searchByTitleBtn"
              @click="setSearchPosition('TITLE'), (positionBtnFlag = false)"
            >
              标题
            </button>
            <button
              :class="positionBtnFlag ? 'cur' : ''"
              id="searchByArticleBtn"
              @click="setSearchPosition(''), (positionBtnFlag = true)"
            >
              全文
            </button>
          </div>
          <div class="search_option">
            <span>时间范围：</span>
            <div class="date_option">
              <el-date-picker
                v-model="searchListParamsTimeArr"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :editable="false"
                :clearable="true"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                @change="setSearchTime"
              >
              </el-date-picker>
            </div>
          </div>
        </div>
        <!-- 搜索结果列表 -->
        <div class="fl search_list_box">
          <!-- 提示信息 -->
          <div class="tips_box" v-show="tipsBoxFlag">
            <p style="margin-bottom: 15px">
              为您找到相关结果约<span id="searchResCount" class="red">{{
                searchCount
              }}</span
              >个。
            </p>
            <p v-show="keywordsCorrect">
              已显示
              <span id="searchKeyWordCorrect">“{{ keywordsCorrect }}”</span
              >的搜索结果。
              <b>仍然搜索：</b>
              <a
                href="javascript:;"
                id="searchKeyWord"
                @click="setSearchStillSearching(true)"
                >{{ keywordsShow }}</a
              >
            </p>
          </div>

          <!-- 服务页面才出现地区选项卡 -->
          <RegionSelect
            v-if="serviceFlag"
            @getRegionInfo="getRegionInfo"
            @drawServiceList="drawServiceList"
          ></RegionSelect>

          <ul class="search_list" id="searchList">
            <!-- 搜索结果-嵌套 -->
            <li
              class="res_iframe"
              v-show="chart.flag && searchListParams.type === ''"
            >
              <div class="res_iframe_box">
                <iframe
                  :src="chart.url"
                  frameborder="0"
                  width="100%"
                  height="100%"
                ></iframe>
              </div>
            </li>
            <!-- 搜索结果-专题解读 -->
            <li
              class="res_jiedu"
              v-show="specialJiedu.flag && searchListParams.type === ''"
            >
              <div class="res_jiedu_img_list">
                <div class="res_jiedu_img_list_left">
                  <!-- <img src="../assets/picture/002.png" alt=""> -->
                  <a target="_blank" :href="specialJiedu.img.url">
                    <img :src="specialJiedu.img.imgUrl" alt="" />
                  </a>
                </div>
                <div class="res_jiedu_img_list_right">
                  <ul>
                    <li v-for="item in specialJiedu.list">
                      <a
                        target="_blank"
                        :href="item.url"
                        :title="inputWordsReplaceFn(item.title, 2)"
                        v-html="item.title"
                      ></a>
                    </li>
                  </ul>
                </div>
              </div>
              <el-tabs
                class="res_jiedu_tab_pane"
                v-model="specialJiedu.columnActiveName"
                v-show="toBoolean(specialJiedu.column) === true"
              >
                <el-tab-pane
                  :label="item1.columnName"
                  :name="'0' + index1"
                  v-for="(item1, index1) in specialJiedu.column"
                >
                  <ul class="res_jiedu_pane_ul">
                    <li v-for="item2 in item1.articleArr.slice(0, 3)">
                      <a
                        target="_blank"
                        :href="item2.url"
                        :title="inputWordsReplaceFn(item2.title, 3)"
                        v-html="item2.title"
                      ></a
                      ><span>{{ item2.date }}</span>
                    </li>
                    <li class="res_jiedu_more">
                      <a target="_blank" :href="item1.moreUrl">更多>></a>
                    </li>
                  </ul>
                </el-tab-pane>
              </el-tabs>
            </li>

            <!-- 搜索结果-服务 -->
            <li
              class="res_service"
              v-show="sugServiceList.length !== 0 && sugServiceListShowFlag"
            >
              <div class="res_service_title sug_title">
                <span class="fl">服务</span>
                <a
                  target="_blank"
                  href="http://zwfw.hubei.gov.cn/webview/fw/grfw.html?areaId=429004000000&type=zt"
                  class="fr"
                  >湖北省政务服务网>></a
                >
              </div>
              <ul class="res_service_list">
                <li
                  v-for="item in sugServiceList"
                  v-show="item.url && item.title"
                >
                  <a
                    target="_blank"
                    :href="item.url"
                    :title="inputWordsReplaceFn(item.title, 4)"
                    v-html="item.title"
                  ></a>
                  <button class="sug_service_consult">
                    <a target="_blank" :href="item.url">咨询</a>
                  </button>
                  <button class="sug_service_handle">
                    <a target="_blank" :href="item.url">办理</a>
                  </button>
                </li>
              </ul>
            </li>
            <!-- 搜索结果-文章 -->
            <li
              class="res_article"
              v-for="item in searchList"
              v-show="(item.url && item.title) || item.photo"
            >
              <div class="res_article_title" v-show="!item.photo">
                <span class="type" v-show="item.type" v-html="item.type"></span>
                <a
                  target="_blank"
                  :href="item.url"
                  :title="inputWordsReplaceFn(item.title, 5)"
                  v-show="item.title"
                  v-html="item.title"
                ></a>
                <span
                  class="pubdate"
                  v-show="item.time"
                  v-html="item.time"
                ></span>
              </div>
              <div
                class="res_article_table"
                v-show="
                  item.indexNum || item.interpretationUnit || item.taskCode
                "
              >
                <table
                  border="0"
                  cellpadding="0"
                  cellspacing="0"
                  class="res_article_table_md"
                >
                  <tbody>
                    <tr>
                      <th colspan="1" v-show="item.indexNum">索引号</th>
                      <td
                        colspan="3"
                        v-show="item.indexNum"
                        v-html="item.indexNum"
                      ></td>
                      <th colspan="1" v-show="item.theme">主题分类</th>
                      <td
                        colspan="3"
                        v-show="item.theme"
                        v-html="item.theme"
                      ></td>
                    </tr>
                    <tr>
                      <th colspan="1" v-show="item.interpretationUnit">
                        解读单位
                      </th>
                      <td
                        colspan="3"
                        v-show="item.interpretationUnit"
                        v-html="item.interpretationUnit"
                      ></td>
                      <th colspan="1" v-show="item.publisher">发文单位</th>
                      <td
                        colspan="3"
                        v-show="item.publisher"
                        v-html="item.publisher"
                      ></td>
                      <th colspan="1" v-show="item.time">发文日期</th>
                      <td
                        colspan="3"
                        v-show="item.time"
                        v-html="item.time"
                      ></td>
                    </tr>
                    <tr>
                      <th colspan="1" v-show="item.docNum">发文字号</th>
                      <td
                        colspan="3"
                        v-show="item.docNum"
                        v-html="item.docNum"
                      ></td>
                      <th colspan="1" v-show="item.effect">效力状态</th>
                      <td
                        colspan="3"
                        v-show="item.effect"
                        v-html="item.effect"
                      ></td>
                    </tr>

                    <tr>
                      <th colspan="1" v-show="item.interpretationType">
                        解读类型
                      </th>
                      <td
                        colspan="3"
                        v-show="item.interpretationType"
                        v-html="item.interpretationType"
                      ></td>
                      <th colspan="1" v-show="item.interpretationWay">
                        解读方式
                      </th>
                      <td
                        colspan="3"
                        v-show="item.interpretationWay"
                        v-html="item.interpretationWay"
                      ></td>
                    </tr>

                    <tr>
                      <th colspan="1" v-show="item.taskCode">实施编码</th>
                      <td
                        colspan="3"
                        v-show="item.taskCode"
                        v-html="item.taskCode"
                      ></td>
                      <th colspan="1" v-show="item.taskType">事项类型</th>
                      <td
                        colspan="3"
                        v-show="item.taskType"
                        v-html="item.taskType"
                      ></td>
                    </tr>
                    <tr></tr>
                    <tr>
                      <th colspan="1" v-show="item.transactCode">
                        业务办理项编码
                      </th>
                      <td
                        colspan="3"
                        v-show="item.transactCode"
                        v-html="item.transactCode"
                      ></td>
                      <th colspan="1" v-show="item.taskDept">实施主体</th>
                      <td
                        colspan="3"
                        v-show="item.taskDept"
                        v-html="item.taskDept"
                      ></td>
                    </tr>
                  </tbody>
                </table>
                <table
                  border="0"
                  cellpadding="0"
                  cellspacing="0"
                  class="res_article_table_xs"
                >
                  <tbody>
                    <tr>
                      <th colspan="1" v-show="item.indexNum">索引号</th>
                      <td
                        colspan="3"
                        v-show="item.indexNum"
                        v-html="item.indexNum"
                      ></td>
                    </tr>
                    <tr>
                      <th colspan="1" v-show="item.interpretationUnit">
                        解读单位
                      </th>
                      <td
                        colspan="3"
                        v-show="item.interpretationUnit"
                        v-html="item.interpretationUnit"
                      ></td>
                    </tr>
                    <tr>
                      <th colspan="1" v-show="item.theme">主题分类</th>
                      <td
                        colspan="3"
                        v-show="item.theme"
                        v-html="item.theme"
                      ></td>
                    </tr>
                    <tr>
                      <th colspan="1" v-show="item.publisher">发文单位</th>
                      <td
                        colspan="3"
                        v-show="item.publisher"
                        v-html="item.publisher"
                      ></td>
                    </tr>
                    <tr>
                      <th colspan="1" v-show="item.time">发布日期</th>
                      <td
                        colspan="3"
                        v-show="item.time"
                        v-html="item.time"
                      ></td>
                    </tr>
                    <tr>
                      <th colspan="1" v-show="item.docNum">发文字号</th>
                      <td
                        colspan="3"
                        v-show="item.docNum"
                        v-html="item.docNum"
                      ></td>
                    </tr>
                    <tr>
                      <th colspan="1" v-show="item.effect">效力状态</th>
                      <td
                        colspan="3"
                        v-show="item.effect"
                        v-html="item.effect"
                      ></td>
                    </tr>
                    <tr>
                      <th colspan="1" v-show="item.interpretationType">
                        解读类型
                      </th>
                      <td
                        colspan="3"
                        v-show="item.interpretationType"
                        v-html="item.interpretationType"
                      ></td>
                    </tr>
                    <tr>
                      <th colspan="1" v-show="item.interpretationWay">
                        解读方式
                      </th>
                      <td
                        colspan="3"
                        v-show="item.interpretationWay"
                        v-html="item.interpretationWay"
                      ></td>
                    </tr>
                    <tr>
                      <th colspan="1" v-show="item.taskCode">实施编码</th>
                      <td
                        colspan="3"
                        v-show="item.taskCode"
                        v-html="item.taskCode"
                      ></td>
                    </tr>
                    <tr>
                      <th colspan="1" v-show="item.taskType">事项类型</th>
                      <td
                        colspan="3"
                        v-show="item.taskType"
                        v-html="item.taskType"
                      ></td>
                    </tr>
                    <tr>
                      <th colspan="1" v-show="item.transactCode">
                        业务办理项编码
                      </th>
                      <td
                        colspan="3"
                        v-show="item.transactCode"
                        v-html="item.transactCode"
                      ></td>
                    </tr>
                    <tr>
                      <th colspan="1" v-show="item.taskDept">实施主体</th>
                      <td
                        colspan="3"
                        v-show="item.taskDept"
                        v-html="item.taskDept"
                      ></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="res_leader_info" v-show="item.photo">
                <div class="res_leader_img">
                  <img :src="item.photo" alt="" />
                </div>
                <div class="res_leader_details">
                  <div class="res_leader_name">
                    <a target="_blank" :href="item.url" v-html="item.name"></a>
                  </div>
                  <p class="res_leader_work">
                    <span v-html="item.exp"></span>
                  </p>
                  <p class="res_leader_exp">
                    分工：<span v-html="item.work"></span>
                  </p>
                  <button class="res_leader_zt">
                    <a target="_blank" :href="item.url">进入我的专题</a>
                  </button>
                </div>
              </div>
              <div class="res_article_content" v-show="item.content">
                <p v-html="item.content"></p>
              </div>
              <div class="res_article_service" v-show="item.taskCode">
                <a target="_blank" :href="item.url">查看评价</a>
                <span>|</span>
                <a target="_blank" :href="item.url">咨询</a>
                <span>|</span>
                <a target="_blank" :href="item.url">收藏</a>
                <span>|</span>
                <a target="_blank" :href="item.url">在线办理</a>
              </div>
              <div class="res_article_link" v-show="item.url">
                <a class="green_link" target="_blank" :href="item.url">{{
                  item.url
                }}</a>
              </div>
            </li>
            <!-- 搜索结果-请输入关键词 -->
            <!-- <li class="res_none" v-show="!keywords">
              <p>请输入搜索关键词</p>
            </li> -->
            <!-- 搜索结果-无结果 -->
            <li class="res_none" v-show="showListNoneFlag">
              <p>抱歉，没有搜索到相关的信息</p>
            </li>
            <!-- 搜索结果-服务页无结果 -->
            <li
              class="res_none"
              v-show="
                serviceListParams.type === '9693' && showServiceListNoneFlag
              "
            >
              <p>抱歉，没有搜索到相关的信息</p>
            </li>
          </ul>
          <div>
            <!-- 服务页面的页码 -->
            <el-pagination
              v-if="serviceFlag"
              background
              @current-change="handleServiceCurrentChange"
              :current-page.sync="serviceCurrentPage"
              layout="prev, pager, next, jumper"
              prev-text="上一页"
              next-text="下一页"
              :page-size="10"
              :total="serviceTotal"
              hide-on-single-page
              :pager-count="5"
            >
            </el-pagination>
            <!-- 非服务页面的页码 -->
            <el-pagination
              v-else-if="!serviceFlag"
              background
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              layout="prev, pager, next, jumper"
              prev-text="上一页"
              next-text="下一页"
              :page-size="10"
              :total="total"
              hide-on-single-page
              :pager-count="5"
            >
            </el-pagination>
          </div>

          <!-- hide-on-single-page -->
          <!-- :total="total" -->
        </div>

        <!-- 智能推荐列表 -->
        <div class="fr suggest_list_box">
          <!-- 智能推荐 -->
          <div
            class="intelligent_sug_box"
            v-show="keywordsShow || keywordsCorrect"
          >
            <div class="sug_intelligent_title sug_title">
              <span class="fl">智能推荐</span>
            </div>
            <p>
              <span id="searchKeyWordCorrect2">{{
                keywordsCorrect === null || !keywordsCorrect
                  ? keywordsShow
                  : keywordsCorrect
              }}</span
              >的智能推荐
            </p>
            <SugFile :list="sugFileList"></SugFile>
            <SugPublic :list="sugPublicList"></SugPublic>
            <SugExplain :list="sugExplainList"></SugExplain>
          </div>
          <!-- 相关搜索 -->
          <Relation
            :list="relatedWordsArr"
            @addKeywordsToSearchInput="addKeywordsToSearchInput"
          ></Relation>
          <!-- 历史搜索 -->
          <History
            :list="historyArr"
            @addKeywordsToSearchInput="addKeywordsToSearchInput"
          ></History>
        </div>
      </div>
    </main>
    <!-- main结束 -->
  </div>
</template>

<script>
import RegionSelect from '@/components/RegionSelect'
import SugFile from '@/components/right/SugFile.vue'
import SugPublic from '@/components/right/SugPublic.vue'
import SugExplain from '@/components/right/SugExplain.vue'
import Relation from '@/components/right/Relation.vue'
import History from '@/components/right/History.vue'

import {
  getDataAxiosApi,
  getNavListApi,
  getSearchListApi,
  getHotWordsApi,
  getSuggestWordsApi,
  getRelatedWordsApi,
  marrySpecialJieduListApi,
  marryChartListApi,
  getServiceListApi
} from '@/api/api'
import {
  getRequest,
  changeURLStatic,
  highLight,
  inputWordsReplaceFn,
  arrDeepCopy,
  uniqueArr,
  toBoolean,
  scrollToTop
} from '@/utils/utils'

import {
  effectFlag,
  interpretationTypeFlag,
  readingWayFlag,
  taskTypeFlag
} from '@/utils/dataDict'

export default {
  name: 'Header',
  components: {
    RegionSelect,
    SugFile,
    SugPublic,
    SugExplain,
    Relation,
    History
  },
  data() {
    return {
      // 用于获取数据的参数
      searchListParams: {
        code: 'f94bae971eac493eb5ec3d6429b94a81', // 搜索编码
        siteId: 63, // 站点
        pageNumber: 1, // 当前页数
        pageSize: 10, // 每页条数
        searchWord: '武汉', // 搜索关键词
        type: '', // 栏目
        orderBy: 'all', // 排序方式，all按相关度，time按时间
        timeOrder: '', // 时间排序需加timeOrder: desc
        position: '', // 搜索范围，''全文，TITLE标题
        time: '', // 搜索时间范围，逗号分隔，如2019-06-10,2019-06-16
        stillSearching: false // 仍然搜索，''纠正，true仍然搜索
      },
      // 用于传递数据的中间值
      keywords: '', // 搜索关键词
      keywordsCorrect: '', // 搜索关键词纠正
      searchListParamsTimeArr: [], // 搜索参数time的数组形式
      total: 0, // 分页-总条数（数值）
      // 用于展示数据的参数
      keywordsShow: '', // 展示在页面上的关键词
      searchCount: 0, // 搜索结果数（字符串）
      // 用于存放展示数据的数组
      navObjListArr: [], // nav栏（含title和typeId）
      hotWordsArr: [], // 搜索热词
      suggestWordsArr: [], // 搜索智能联想
      searchList: [], // 搜索结果
      sugServiceList: [], // 智能推荐-服务2条
      sugFileList: [], // 智能推荐-文件3条
      sugPublicList: [], // 智能推荐-公开3条
      sugExplainList: [], // 智能推荐-解读3条
      relatedWordsArr: [], // 相关搜索
      historyArr: [], // 历史记录

      // 开关
      tipsBoxFlag: false, // 提示信息开关
      navActiveName: '全部', // nav当前激活项
      suggestWordsFlag: false, // 搜索智能联想开关
      searchInputClearBtnFlag: false, // 搜索清除按钮开关
      sugServiceListShowFlag: false, // 服务-显示开关（nav为“全部”时显示）
      currentPage: 1, // 分页-当前激活页
      showListNoneFlag: false, // 显示无搜索结果
      showServiceListNoneFlag: false, // 服务页显示无搜索结果
      sortBtnFlag: true, // 排序按钮样式开关，true-相关度，false-时间
      positionBtnFlag: true, // 搜索范围按钮样式开关，true-全文，false-标题
      paginationShow: false, // 页面组件是否显示，解决total更新，导致current-page未被激活的问题
      serviceFlag: false, // 服务页面开关

      // 专题查询
      specialJiedu: {
        flag: false, // 专题解读-匹配开关
        img: {}, // 专题解读-图片
        list: [], // 专题解读-列表
        column: [], // 专题解读-栏目列表
        columnActiveName: '00' // 专题解读-当前激活栏目name
      },
      // 图表查询
      chart: {
        flag: false, // 图表-匹配开关
        url: false // 图表-嵌套链接
      },

      // 服务页查询参数
      serviceListParams: {
        pageNum: 1,
        areaGrade: '3',
        regionCode: '429006000000'
      },
      serviceCurrentPage: 1,
      serviceTotal: 0
    }
  },
  directives: {
    // 点击外部区域才触发事件
    'click-outside': {
      bind(el, binding, vnode) {
        // console.log('bind')
        function eventHandler(e) {
          if (el.contains(e.target)) {
            return false
          }
          // 如果绑定的参数是函数，正常情况也应该是函数，执行
          if (binding.value && typeof binding.value === 'function') {
            binding.value(e)
          }
        }
        // 用于销毁前注销事件监听
        el.__click_outside__ = eventHandler
        // 添加事件监听
        document.addEventListener('click', eventHandler)
      },

      unbind(el, binding, vnode) {
        // console.log('unbind')

        // 移除事件监听
        document.removeEventListener('click', el.__click_outside__)
        // 删除无用属性
        delete el.__click_outside__
      }
    }
  },
  mounted() {
    scrollToTop()
    this.getHistory()

    this.getData()
  },
  methods: {
    getRequest,
    changeURLStatic,
    highLight,
    inputWordsReplaceFn,
    arrDeepCopy,
    uniqueArr,
    toBoolean,
    scrollToTop,
    handleClickOutside() {
      this.initSearchInputFlag()
    },
    getData() {
      Promise.all([this.getNavList(), this.getHotWords()]).then((res) => {
        this.searchMountedFn()
      })
    },

    // 初始的搜索
    async searchMountedFn() {
      getRequest(this.searchListParams)

      this.sugServiceListShowFlag = true
      this.keywords = this.searchListParams.searchWord
      this.keywordsShow = this.searchListParams.searchWord
      this.currentPage = parseInt(this.searchListParams.pageNumber)
      this.addHistory(this.searchListParams.searchWord)

      if (this.getColumnTitle(this.searchListParams.type) === '服务') {
        this.serviceFlag = true
        this.drawServiceList()
        // this.marrySpecialJieduList()
        // this.marryChartList()
        this.getSugFileList()
        this.getSugPublicList()
        this.getSugJieduList()
        this.getRelatedWords()
      } else {
        this.serviceFlag = false
        this.searchBySearchWords()
      }
    },

    // 搜索-前台
    searchFn() {
      // 是否为空
      if (this.keywords === '') {
        //为空
        alert('请输入搜索关键词')
      } else {
        // 不为空
        this.init()
        this.initUrl()

        this.sugServiceListShowFlag = true
        this.searchListParams.searchWord = this.keywords
        this.keywordsShow = this.searchListParams.searchWord
        this.addHistory(this.searchListParams.searchWord)
        this.searchBySearchWords()
      }
      scrollToTop()
    },
    // 搜索-后台
    searchBySearchWords() {
      // console.log('搜索的是:' + this.searchListParams.searchWord)
      this.getSearchList()
      // this.marrySpecialJieduList()
      // this.marryChartList()
      this.getSugServiceList()
      this.getSugFileList()
      this.getSugPublicList()
      this.getSugJieduList()
      this.getRelatedWords()
    },

    // 全部初始化
    init() {
      this.initSearchListParams()
      this.initSearchListOptions()
      this.initRetrieval()
      this.initSearchInputFlag()
    },
    // 地址栏初始化
    initUrl() {
      // console.log("0:"+location.href);
      var initUrl = location.origin + location.pathname + ''
      history.replaceState(null, null, initUrl) // 替换地址栏
      // console.log("1:"+location.href);
      changeURLStatic('searchWord', this.keywords)
      // console.log("2:"+location.href);
      changeURLStatic('siteId', 63)
      // console.log("3:"+location.href);
      // changeURLStatic('pageNumber', 1)
      // console.log("4:"+location.href);
      changeURLStatic('pageSize', 10)
      // console.log("5:"+location.href);
      //   changeURLStatic('type', '');
      //   changeURLStatic('orderBy', 'all');
      //   changeURLStatic('timeOrder', '');
      //   changeURLStatic('position', '');
      //   changeURLStatic('time', '');
      //   changeURLStatic('stillSearching', false);
    },
    // 搜索参数初始化
    initSearchListParams() {
      this.searchListParams = {
        code: 'f94bae971eac493eb5ec3d6429b94a81', // 搜索编码
        siteId: 63, // 站点
        pageNumber: 1, // 当前页数
        pageSize: 10, // 每页条数
        searchWord: '武汉', // 搜索关键词
        type: '', // 栏目
        orderBy: 'all', // 排序方式，all按相关度，time按时间
        timeOrder: '', // 时间排序需加timeOrder: desc
        position: '', // 搜索范围，''全文，TITLE标题
        time: '', // 搜索时间范围，逗号分隔，如2019-06-10,2019-06-16
        stillSearching: false // 仍然搜索，''纠正，true仍然搜索
      }
      this.sugServiceListShowFlag = false
    },
    // 搜索选项样式初始化
    initSearchListOptions() {
      this.navActiveName = '全部'
      this.sortBtnFlag = true
      this.positionBtnFlag = true
      this.searchListParamsTimeArr = null
    },
    // 专题检索、图表检索初始化
    initRetrieval() {
      // 专题查询
      this.specialJiedu = {
        flag: false, // 专题解读-匹配开关
        img: {}, // 专题解读-图片
        list: [], // 专题解读-列表
        column: [], // 专题解读-栏目列表
        columnActiveName: '00' // 专题解读-当前激活栏目name
      }
      // 图表查询
      this.chart = {
        flag: false, // 图表-匹配开关
        url: false // 图表-嵌套链接
      }
    },
    // 搜索框样式初始化
    initSearchInputFlag() {
      this.suggestWordsFlag = false
      this.searchInputClearBtnFlag = false
    },

    // 搜索智能联想-显示
    showSuggestWords() {
      if (this.keywords !== '') {
        this.searchInputClearBtnFlag = true
        this.suggestWordsFlag = true
      } else {
        this.initSearchInputFlag()
      }
    },
    // 清除搜索框内容
    clearSearchInputFn() {
      this.keywords = ''
      this.suggestWordsArr = []
      this.initSearchInputFlag()
    },
    // 填充搜索框并搜索
    addKeywords(e) {
      this.addKeywordsToSearchInput(e.target.innerText)
    },
    addKeywordsToSearchInput(text) {
      this.keywords = text
      this.searchFn()
    },

    // 获取nav栏数据
    async getNavList() {
      var res = await getNavListApi({
        code: this.searchListParams.code // 站点
      })
      this.navObjListArr = res.type.map((resObj) => {
        return {
          title: resObj.term,
          typeId: resObj.id
        }
      })
      // 手动补一个全部栏目
      this.navObjListArr.unshift({
        title: '全部',
        typeId: ''
      })
    },
    // nav栏切换功能
    async navHandleClick(tab, e) {
      const typeTitle = e.target.innerText
      this.navObjListArr.forEach((item) => {
        if (typeTitle === item.title) {
          this.initSearchInputFlag()
          this.searchListParams.type = item.typeId
          typeTitle === '全部'
            ? (this.sugServiceListShowFlag = true)
            : (this.sugServiceListShowFlag = false)
        }
      })
      scrollToTop()
      if (typeTitle !== '服务') {
        this.searchListParams.pageNumber = 1 // 页码重置
        await this.getSearchList()
        changeURLStatic('type', this.searchListParams.type)
      } else {
        this.serviceListParams = {
          pageNum: 1,
          areaGrade: '3',
          regionCode: '429006000000'
        }
        this.drawServiceList()
        changeURLStatic('type', this.getColumnTypeId('服务'))
      }
    },

    // 设置搜索orderBy
    setSearchOrderBy(value) {
      this.searchListParams.orderBy = value
      this.searchListParams.pageNumber = 1
      this.getSearchList()
      changeURLStatic('orderBy', value)
    },
    // 设置搜索timeOrder
    setSearchTimeOrder(value) {
      this.searchListParams.timeOrder = value
      this.searchListParams.pageNumber = 1
      this.getSearchList()
      changeURLStatic('timeOrder', value)
    },
    // 设置搜索position
    setSearchPosition(value) {
      this.searchListParams.position = value
      this.searchListParams.pageNumber = 1
      this.getSearchList()
      changeURLStatic('position', value)
    },
    // 设置搜索time
    setSearchTime() {
      if (
        this.searchListParamsTimeArr !== null &&
        this.searchListParamsTimeArr.length !== 0
      ) {
        this.searchListParams.time =
          this.searchListParamsTimeArr[0] +
          ',' +
          this.searchListParamsTimeArr[1]
      } else {
        this.searchListParams.time = ''
      }
      this.searchListParams.pageNumber = 1
      this.getSearchList()
      changeURLStatic('time', this.searchListParams.time)
    },
    // 设置仍然搜索stillSearching
    setSearchStillSearching(value) {
      this.searchListParams.stillSearching = value
      this.searchListParams.pageNumber = 1
      this.searchBySearchWords()
      changeURLStatic('stillSearching', value)
    },

    // 搜索热词
    async getHotWords() {
      var res = await getHotWordsApi({
        siteId: this.searchListParams.siteId // 站点
      })
      res.forEach((item, index) => {
        if (index < 8) {
          this.hotWordsArr.push(item.name)
        }
      })
    },

    // 获取搜索列表
    async getSearchList() {
      var { page: res } = await getSearchListApi(this.searchListParams)
      if (res) {
        this.tipsBoxFlag = true
        this.searchList = []
        // 显示最大页码为1000页
        res.total > 1000 * this.searchListParams.pageSize
          ? (this.total = 1000 * this.searchListParams.pageSize)
          : (this.total = parseInt(res.total))
        this.searchCount = res.total

        this.isShowListNone()

        this.keywordsCorrect = res.correctWord
        var newArr = []
        res.content.forEach((obj) => {
          var newObj = {}
          for (var key in obj) {
            if (key === 'CHNLDESC') {
              newObj.type = toBoolean(obj[key]) ? obj[key] : ''
            } else if (
              key === 'title' ||
              key === 'DOCTITLE' ||
              key === 'FileName' ||
              key === 'TransactName'
            ) {
              newObj.title = toBoolean(obj[key]) ? obj[key] : ''
            } else if (key === 'trs_time' || key === 'PUBDATE') {
              newObj.time = toBoolean(obj[key]) ? obj[key].substring(0, 10) : ''
            } else if (key === 'content' || key === 'DOCCONTENT') {
              newObj.content = toBoolean(obj[key]) ? obj[key] : ''
            } else if (key === 'url' || key === 'DOCPUBURL') {
              newObj.url = toBoolean(obj[key]) ? obj[key] : ''
            } else if (key === 'IdxID') {
              newObj.indexNum = toBoolean(obj[key]) ? obj[key] : ''
            } else if (key === 'publisher') {
              newObj.publisher = toBoolean(obj[key]) ? obj[key] : ''
            } else if (key === 'fileNum') {
              newObj.docNum = toBoolean(obj[key]) ? obj[key] : '无'
            } else if (key === 'CNAME') {
              newObj.theme = toBoolean(obj[key]) ? obj[key] : ''
            } else if (key === 'Effectivestate') {
              newObj.effect = toBoolean(effectFlag(obj[key]))
                ? effectFlag(obj[key])
                : ''
            } else if (key === 'InterpretationUnit') {
              newObj.interpretationUnit = toBoolean(obj[key]) ? obj[key] : ''
            } else if (key === 'Interpretationtype') {
              newObj.interpretationType = toBoolean(
                interpretationTypeFlag(obj[key])
              )
                ? interpretationTypeFlag(obj[key])
                : ''
            } else if (key === 'Readingway') {
              newObj.interpretationWay = toBoolean(readingWayFlag(obj[key]))
                ? readingWayFlag(obj[key])
                : ''
            } else if (key === 'taskCode') {
              newObj.taskCode = toBoolean(obj[key]) ? obj[key] : ''
            } else if (key === 'TaskType') {
              newObj.taskType = toBoolean(taskTypeFlag(obj[key]))
                ? taskTypeFlag(obj[key])
                : ''
            } else if (key === 'transactCode') {
              newObj.transactCode = toBoolean(obj[key]) ? obj[key] : ''
            } else if (key === 'DeptName') {
              newObj.taskDept = toBoolean(obj[key]) ? obj[key] : ''
            } else if (key === 'tx') {
              newObj.photo = toBoolean(obj[key]) ? obj[key] : ''
            } else if (key === 'rm') {
              newObj.name = toBoolean(obj[key]) ? obj[key] : ''
            } else if (key === 'ldfg') {
              newObj.work = toBoolean(obj[key]) ? obj[key] : ''
            } else if (key === 'drzw') {
              newObj.exp = toBoolean(obj[key]) ? obj[key] : ''
            } else if (key === 'url') {
              newObj.url = toBoolean(obj[key]) ? obj[key] : ''
            }
          }
          // console.log(newObj)
          newArr.push(newObj)
        })
        // console.log(newArr)

        this.searchList = arrDeepCopy(newArr)
        console.log('getSearchList', this.searchList)
      }
    },
    // 判断是否有搜索结果，无结果则提示
    isShowListNone() {
      if (this.searchCount === '0' || this.searchCount === 0) {
        this.showListNoneFlag = true
      } else {
        this.showListNoneFlag = false
      }
    },
    // 判断服务页是否有搜索结果，无结果则提示
    isShowServiceListNone() {
      if (this.serviceTotal === '0' || this.serviceTotal === 0) {
        this.showServiceListNoneFlag = true
      } else {
        this.showServiceListNoneFlag = false
      }
    },

    // 获取智能推荐-服务、文件、公开、解读
    async getRecommendList(type) {
      var { page: res } = await getSearchListApi({
        code: this.searchListParams.code, // 搜索编码
        siteId: this.searchListParams.siteId, // 站点
        pageNumber: 1, // 当前页数
        pageSize: 10, // 每页条数
        searchWord: this.searchListParams.searchWord, // 搜索关键词
        type: type, // 栏目
        orderBy: 'all', // 排序方式，all按相关度，time按时间
        stillSearching: this.searchListParams.stillSearching
      })

      var newArr = []
      // console.log('type', type, res)
      if (toBoolean(res.content) === false) {
        newArr = []
        return newArr
      } else {
        res.content.forEach((obj) => {
          var newObj = {}
          for (var key in obj) {
            if (
              key === 'title' ||
              key === 'DOCTITLE' ||
              key === 'FileName' ||
              key === 'TransactName'
            ) {
              newObj.title = toBoolean(obj[key]) ? obj[key] : ''
            } else if (key === 'url' || key === 'DOCPUBURL') {
              newObj.url = toBoolean(obj[key]) ? obj[key] : ''
            }
          }
          // console.log(newObj)
          newArr.push(newObj)
        })
        // console.log(newArr)
        return newArr
      }
    },
    // 匹配栏目title
    getColumnTitle(columnTypeId) {
      for (var item of this.navObjListArr) {
        if (item.typeId === columnTypeId) {
          // console.log(item.title)
          return item.title
        }
      }
    },
    // 匹配栏目ID
    getColumnTypeId(columnTitle) {
      for (var item of this.navObjListArr) {
        if (item.title === columnTitle) {
          // console.log(columnTitle);
          return item.typeId
        }
      }
    },

    // 获取智能推荐-服务（新）
    // 获取地区信息
    getRegionInfo(areaGrade, regionCode) {
      this.serviceListParams.areaGrade = areaGrade
      this.serviceListParams.regionCode = regionCode
    },
    async getServiceList() {
      const res = await getServiceListApi({
        pageNum: this.serviceListParams.pageNum,
        areaGrade: this.serviceListParams.areaGrade,
        keyword: this.searchListParams.searchWord,
        regionCode: this.serviceListParams.regionCode
      })

      var type = this.getColumnTypeId('服务') // 用于标识当前type

      if (res.data) {
        if (this.searchListParams.type === type) {
          this.tipsBoxFlag = true
          this.searchList = []
          this.serviceTotal = res.data.total
          this.isShowServiceListNone()
        }

        res.data.records.map((i) => {
          i.type = '办事服务'
          i.url =
            'http://zwfw.hubei.gov.cn/webview/bszn/bsznpage.html?transactCode=' +
            i.transactCode
          i.title = toBoolean(i.highlightTransactName)
            ? i.highlightTransactName
            : ''
          i.taskCode = toBoolean(i.taskCode) ? i.taskCode : ''
          i.taskType = toBoolean(taskTypeFlag(i.taskType))
            ? taskTypeFlag(i.taskType)
            : ''
          i.transactCode = toBoolean(i.transactCode) ? i.transactCode : ''
          i.taskDept = toBoolean(i.shortOrgName) ? i.shortOrgName : ''
          return i
        })
        return res
      }
    },
    async drawServiceList() {
      const res = await this.getServiceList()
      this.keywordsShow = this.searchListParams.searchWord
      this.searchCount = res.data.total
      this.searchList = res.data.records
    },
    async getSugServiceList() {
      var type = this.getColumnTypeId('服务') // 用于标识当前type
      this.sugServiceList = []
      this.serviceListParams = {
        pageNum: 1,
        areaGrade: '3',
        regionCode: '429006000000'
      }
      const res = await this.getServiceList()
      this.sugServiceList = res.data.records.slice(0, 5)
    },
    // async getSugServiceList() {
    //   var type = this.getColumnTypeId('服务')
    //   var res = await this.getRecommendList(type)
    //   this.sugServiceList = res.slice(0, 5)
    //   // console.log('服务',type);
    // },
    async getSugFileList() {
      var type = this.getColumnTypeId('文件')
      var res = await this.getRecommendList(type)
      this.sugFileList = res.slice(0, 5)
      // console.log('文件',type);
    },
    async getSugPublicList() {
      var type = this.getColumnTypeId('公开')
      var res = await this.getRecommendList(type)
      this.sugPublicList = res.slice(0, 5)
      // console.log('公开',type);
    },
    async getSugJieduList() {
      var type = this.getColumnTypeId('解读')
      var res = await this.getRecommendList(type)
      this.sugExplainList = res.slice(0, 5)
      // console.log('解读',type);
    },

    // 获取相关搜索
    async getRelatedWords() {
      this.relatedWordsArr = []
      var res = await getRelatedWordsApi({
        code: this.searchListParams.code, // 搜索编码
        siteId: this.searchListParams.siteId, // 站点
        searchWord: this.searchListParams.searchWord // 搜索关键词
      })
      res.relatedWords.forEach((item) => {
        this.relatedWordsArr.push(item)
      })
    },
    // 历史记录-获取历史记录
    getHistory() {
      if (
        sessionStorage.getItem('historyArr') !== null &&
        sessionStorage.getItem('historyArr').length !== 0
      ) {
        var historyStr = sessionStorage.getItem('historyArr')
        this.historyArr = historyStr.split(',')
      }
    },
    // 历史记录-新增历史记录
    addHistory(val) {
      if (val !== '') {
        this.historyArr.push(val)
      }
      this.historyArr = uniqueArr(this.historyArr)
      sessionStorage.setItem('historyArr', this.historyArr)
    },

    // 匹配专题解读
    // async marrySpecialJieduList() {
    //   var specialJieduResUrl = ''
    //   var resObj = {}
    //   var resJson = await marrySpecialJieduListApi()
    //   resObj = typeof resJson === 'string' ? JSON.parse(resJson) : resJson
    //   resObj.hotsArr.forEach((keyObj) => {
    //     var arr = keyObj.wordArr
    //     var flag = false // 关键词匹配是否成功
    //     arr.forEach((key) => {
    //       if (key === this.searchListParams.searchWord.replace(/\s/g, '')) {
    //         flag = true
    //       }
    //     })
    //     if (flag) {
    //       this.specialJiedu.flag = true
    //       return (specialJieduResUrl =
    //         keyObj.url + '?v=' + new Date().getTime())
    //     }
    //   })
    //   if (this.specialJiedu.flag) {
    //     this.getSpecialJieduList(specialJieduResUrl)
    //   }
    // },
    // 获取专题解读结果
    // async getSpecialJieduList(url) {
    //   var res = await getDataAxiosApi(url)
    //   this.specialJiedu.img = res.swipers[0]
    //   this.specialJiedu.list = res.focusArr
    //   this.specialJiedu.column = res.datas
    // },

    // 匹配图表
    // async marryChartList() {
    //   var chartResUrl = ''
    //   var resObj = {}
    //   var resJson = await marryChartListApi()
    //   resObj = typeof resJson === 'string' ? JSON.parse(resJson) : resJson
    //   resObj.hotsArr.forEach((keyObj) => {
    //     var arr = keyObj.wordArr
    //     var flag = false // 关键词匹配是否成功
    //     arr.forEach((key) => {
    //       if (key === this.searchListParams.searchWord.replace(/\s/g, '')) {
    //         flag = true
    //       }
    //     })
    //     if (flag) {
    //       this.chart.flag = true
    //       return (chartResUrl = keyObj.url + '?v=' + new Date().getTime())
    //     }
    //   })
    //   if (this.chart.flag) {
    //     this.getChartList(chartResUrl)
    //   }
    // },
    // 获取图表结果
    // getChartList(url) {
    //   this.chart.url = url
    // },

    // 分页器
    handleCurrentChange(pageNum) {
      scrollToTop()
      this.searchListParams.pageNumber = pageNum
      this.getSearchList()
      // changeURLStatic('pageNumber', pageNum)
    },
    handleServiceCurrentChange(pageNum) {
      scrollToTop()
      this.serviceListParams.pageNum = pageNum
      this.drawServiceList()
    }
  },
  watch: {
    searchListParams: {
      handler(newVal) {
        this.currentPage = parseInt(this.searchListParams.pageNumber)
        this.searchListParamsTimeArr = this.searchListParams.time.split(',')

        if (this.searchListParams.orderBy === 'all') {
          this.sortBtnFlag = true
        } else {
          this.sortBtnFlag = false
        }

        if (this.searchListParams.position === '') {
          this.positionBtnFlag = true
        } else {
          this.positionBtnFlag = false
        }

        this.navActiveName = this.getColumnTitle(this.searchListParams.type)
        if (this.navActiveName === '服务') {
          this.serviceFlag = true
        } else {
          this.serviceFlag = false
        }
      },
      deep: true
    },
    keywords: {
      async handler(newVal) {
        // console.log('监听到keywords变化', newVal)
        if (newVal !== '') {
          var arr = []
          this.suggestWordsArr = []
          var res = await getSuggestWordsApi({
            code: this.searchListParams.code,
            searchWord: newVal
          })
          res.forEach((item) => {
            var newItem = highLight(item, this.keywords)
            arr.push(newItem)
          })
          this.suggestWordsArr = arr
        } else {
          this.suggestWordsArr = []
        }
        // console.log(this.suggestWordsArr)
      },
      deep: true
    }
  }
}
</script>

<style lang="less"></style>
